import { create } from 'zustand';

type TMaintenanceStore = {
  isMaintenanceMode: boolean;
  isConnected: boolean;
  setMaintenanceMode: (mode: boolean) => void;
  setConnected: () => void;
  setDisconnected: () => void;
};

const useMaintenanceStore = create<TMaintenanceStore>()((set) => ({
  isMaintenanceMode: false,
  isConnected: false,
  setMaintenanceMode: (mode) => set({ isMaintenanceMode: mode }),
  setConnected: () => set({ isConnected: true }),
  setDisconnected: () => set({ isConnected: false, isMaintenanceMode: false }),
}));

export default useMaintenanceStore;
